import { put, call } from "redux-saga/effects";
import ReportesActions from '../../actions/servicio-reportes/Reportes'
import { message } from "antd";
import servicioReportes from "axios/servicio-reportes/Reportes";


//? Listar Reportes de reportes
export function* listReportes () {
  try {
    const listReportes = yield call( servicioReportes.getReportesAxios );
    if (!listReportes.error) {
      yield put(ReportesActions.successReportesAction(listReportes));
    }
  } catch (err) {
    yield message.error('Hubo un error al listar los reportes');
  }
}


//? Agregar Reportes de reportes
export function* addReportes ({ payload }) {
  try {
    const addReportes = yield call(
      servicioReportes.addReportesAxios,
      payload
    );
    
    if (addReportes.msg) {
      yield message.error(addReportes.msg);
    } else {
      
      yield put(ReportesActions.SuccessAddReportesAction());
      yield put(ReportesActions.listReportesAction())
    }
  } catch (err) {
    yield message.error(err.message);
  }
}

//? Eliminar Reportes de reportes
export function* deleteReportes ({ payload }) {
  try {
    const deleteReportes = yield call(
      servicioReportes.deleteReportesAxios,
      payload
    );
    
    console.log('deleteReportes: ', deleteReportes)
    if (deleteReportes.msg) {
      message.success("¡Reporte Eliminado!");
      yield put(ReportesActions.successDeleteReportesAction());
      yield put(ReportesActions.listReportesAction())
    }
  } catch (err) {
    message.error(err.message);
  }
}

//? Eliminar todos los reportes de una unidad de negocio
export function* deleteUnidadNegocioReportes({ payload }) {
  try {
    const result = yield call(servicioReportes.deleteUnidadNegocioAxios, payload);

    if (result?.deletedCount) {
      message.success(result.msg || "Unidad de negocio eliminada");
      yield put(ReportesActions.successDeleteUnidadNegocioReportesAction());
      yield put(ReportesActions.listReportesAction());
      return;
    }

    message.error(result?.msg || "No se pudo eliminar la unidad de negocio");
    yield put(ReportesActions.successDeleteUnidadNegocioReportesAction());
  } catch (err) {
    message.error(err.message);
  }
}

//? Eliminar Actualizar de reportes
export function* updateReportes({ payload }) {
  try {
    const updateCertifcados = yield call(
      servicioReportes.updateReportesAxios,
      payload
    );

    if (updateCertifcados?.msg) {
      message.error(updateCertifcados.msg);
      return;
    }

    if (updateCertifcados?._id) {
      message.success("¡Reporte Editado!");
      yield put(ReportesActions.successUpdateReportesAction());
      yield put(ReportesActions.listReportesAction());
      return;
    }

    message.error("No se pudo actualizar el reporte");
  } catch (err) {
    message.error(err.message);
  }
}

export default {
    listReportes,
    addReportes,
    deleteReportes,
  deleteUnidadNegocioReportes,
    updateReportes
}